<template>
    <div class="cls-main">
        <headers></headers>
        <navmenu></navmenu>
        <banner></banner>
        <router-view class="cls-view"></router-view>
        <footers></footers>
    </div>
</template>
<script>
import headers from "@/components/common/headers";
import navmenu from "@/components/common/navmenu";
import banner from "@/components/common/banner";
import footers from "@/components/common/footers";
export default {
    components: { headers, navmenu, banner, footers },
    data() {
        return {};
    },
    mounted() {
    }
};
</script>
<style lang="less">
// .cls-main {
// }

.cls-view {
    min-height: calc(100vh - 465px);
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue